// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"446":"fd720bd8","868":"0da875c8"}[chunkId] + ".chunk.css";
};